import React from "react";
import { AnimatePresence, motion } from "framer-motion";

export function ScaleSlider({ value, onChange, reactions, lo, hi }) {
    const reaction = value ? reactions[value] : null;
    return (
        <div data-testid="scale-slider">
            <div className="flex items-center justify-between text-xs uppercase tracking-[0.14em] text-klareet-MUT font-mono mb-3">
                <span>{lo}</span>
                <span>{hi}</span>
            </div>
            <div className="grid grid-cols-10 gap-2">
                {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => {
                    const isOn = value === n;
                    return (
                        <motion.button
                            key={n}
                            type="button"
                            onClick={() => onChange(n)}
                            data-testid={`scale-${n}`}
                            aria-label={`${n} of 10`}
                            aria-pressed={isOn}
                            whileHover={{ y: -3 }}
                            whileTap={{ scale: 0.92 }}
                            animate={
                                isOn
                                    ? { y: -4, scale: [1, 1.1, 1] }
                                    : { y: 0, scale: 1 }
                            }
                            transition={{
                                type: "spring",
                                stiffness: 260,
                                damping: 14,
                            }}
                            className={`aspect-square rounded-xl border font-mono text-sm font-medium transition-[background-color,border-color,box-shadow,color] duration-200 ease-out
                                ${
                                    isOn
                                        ? "border-klareet-T bg-klareet-T text-klareet-TEXT shadow-[0_10px_30px_-10px_rgba(13,148,136,0.7)]"
                                        : "border-klareet-bor bg-klareet-card text-klareet-MUT hover:text-klareet-TEXT hover:border-klareet-T/60"
                                }`}
                        >
                            {n}
                        </motion.button>
                    );
                })}
            </div>
            <div className="mt-6 min-h-[64px]">
                <AnimatePresence mode="wait">
                    {reaction ? (
                        <motion.div
                            key={value}
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -6 }}
                            transition={{ duration: 0.25 }}
                            className="flex items-center gap-3 p-4 rounded-xl border border-klareet-bor bg-klareet-card/80"
                        >
                            <motion.span
                                className="text-2xl leading-none"
                                initial={{ scale: 0.8 }}
                                animate={{ scale: [1, 1.15, 1] }}
                                transition={{
                                    duration: 0.5,
                                    times: [0, 0.5, 1],
                                    ease: [0.34, 1.56, 0.64, 1],
                                }}
                            >
                                {reaction.emoji}
                            </motion.span>
                            <span className="text-[15px] text-klareet-TEXT">
                                {reaction.text}
                            </span>
                        </motion.div>
                    ) : (
                        <motion.div
                            key="empty"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="text-sm text-klareet-DIM italic"
                        >
                            Pick a number. Gut check.
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}
